export const initialState = {
  csrf: null
}
